/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid200,
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid401,
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid500,
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationResponse,
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidPathParams,
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidQueryParams,
} from "../../types/pecegePayBilletController/PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid.ts";

export const patchApiV1PecegepayBilletCancelCoursefinpersonpaymentidPathParamsSchema =
  z.object({
    courseFinPersonPaymentId: z.coerce.number().int(),
  }) as unknown as ToZod<PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidPathParams>;

export const patchApiV1PecegepayBilletCancelCoursefinpersonpaymentidQueryParamsSchema =
  z
    .object({
      cancelReason: z.optional(z.string()),
    })
    .optional() as unknown as ToZod<PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const patchApiV1PecegepayBilletCancelCoursefinpersonpaymentid200Schema =
  z.boolean() as unknown as ToZod<PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1PecegepayBilletCancelCoursefinpersonpaymentid401Schema =
  z.any() as unknown as ToZod<PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const patchApiV1PecegepayBilletCancelCoursefinpersonpaymentid500Schema =
  z.any() as unknown as ToZod<PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid500>;

export const patchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationResponseSchema =
  z.lazy(
    () => patchApiV1PecegepayBilletCancelCoursefinpersonpaymentid200Schema,
  ) as unknown as ToZod<PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationResponse>;
